import common from "../modules/common";
import Dotdotdot from "dotdotdot";

const templateHome = {
    init() {
        templateHome.init_slider();
        templateHome.init_news();
        templateHome.init_partners();
        templateHome.init_testimonials();
        templateHome.columns();
    },

    columns() {
        var max = 0;
        $('.columns__title').removeAttr('style').each(function () {
            max = Math.max(max, $(this).height());
        }).css({ minHeight: max });
        $(window).resize(function () {
            var max = 0;
            $('.columns__title').removeAttr('style').each(function () {
                max = Math.max(max, $(this).height());
            }).css({ minHeight: max });
        });
    },

    init_news() {
        $('.news__slider').on('init', function () {
            common.bLazy.load($('.news__image'));
            $('.dot-resize-update').dotdotdot('update');
        })

        $('.news__slider').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            autoplay: false,
            dots: false,
            draggable: false,
            arrows: false,
            prevArrow: '<span class="slick-prev"></span>',
            nextArrow: '<span class="slick-next"></span>',
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1
                    }
                },
            ],
        });



        var a = 0;
        $(window).scroll(function () {

            var oTop = $('#counter').offset().top - window.innerHeight;
            if (a == 0 && $(window).scrollTop() > oTop) {
                $('.counter-value').each(function () {
                    var $this = $(this),
                        countTo = $this.attr('data-count');
                    $({
                        countNum: $this.text()
                    }).animate({
                        countNum: countTo
                    },

                        {

                            duration: 2000,
                            easing: 'swing',
                            step: function () {
                                $this.text(Math.floor(this.countNum));
                            },
                            complete: function () {
                                $this.text(this.countNum);
                            }

                        });
                });
                a = 1;
            }

        });



    },

    init_slider() {

        $('.hero').on('init', function () {
            $(".slick-dots").wrap('<div class="hero__dots"></div>');
            common.bLazy.load($('.hero__lazy'));
        })

        $('.hero').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            fade: true,
            autoplay: true,
            dots: true,
            arrows: false,
            autoplaySpeed: 5000,
            adaptiveHeight: true,
            customPaging: function (slider, i) {
                return '<span></span>';
            }
        });
    },

    init_partners() {
        $('.partners__slider').slick({
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            prevArrow: '<span class="slick-prev"></span>',
            nextArrow: '<span class="slick-next"></span>',
            lazyLoad: 'ondemand',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    },

    init_testimonials() {
        $('.testimonials__slider').on('init', function () {
            bLazy.load($('.testimonials__person__thumb'));
        });

        $('.testimonials__slider').slick({
            adaptiveHeight: false,
            slidesToShow: 1,
            draggable: false,
            prevArrow: '<span class="slick-prev"></span>',
            nextArrow: '<span class="slick-next"></span>',
            dots: true
        });
    }
};

export default templateHome;